import { pick } from "lodash";

export default (analytics) => {
  const appState = {
    search: {
      searchTerm: "",
      identifiedRanges: [],
    },
    timeline: {
      points: {
        usedBy: "PointTrack",
      },
      intervals: {
        usedBy: "BoxTrack",
      },
      channels: {
        usedBy: "BarAxis",
      },
    },
    view: {
      activeTab: 1,
    },
    classifiers: [],
    bookmarks: {
      markers: [],
    },
    parsedFromAnalytics: {
      activeGroup: 0,
      activeSpeaker: 0,
      activeTopic: 0,
      metadata: {},
      topics: [],
      keyWords: [],
      groups: [],
      metrics: [],
      metricGroups: [],
      speakers: [],
      transcript: [],
      fullTurns: [],
      transcriptSpeakers: [],
      classifiers: [],
      detectors: [],
      mediaId: "",
      categories: [],
      verbs: [],
      speakerSentiments: [],
      interactionType: "unknown",
      entities: [],
      summary: [],
      llmCategories: []
    },
    unused: {
      analyticsLoaded: false,
      metadata: [],
      topicsIds: [],
      activeTopic: "",
      groupsIds: [],
      activeGroup: "",
      activeSpeaker: "",
      jobTasks: [],
      mediaUrlLoaded: false,
    },
    player: {
      skipPrevNextHit: false,
      mediaElement: {},
      mediaUrl: "",
      currentTime: 0,
      duration: 0,
      paused: false,
      volume: 0.5,
      playbackRate: 1,
      type: "",
      isSentimentAnalyzerOn: false,
      isKeywordAnalyzerOn: false,
      isPhraseSupportingAnalyzerOn: false,
      isVerbNounAnalyzerOn: false,
    },
  };

  if (analytics) {
    // Apply parsed analytics to appState state :
    const keysToReplace = Object.keys(appState.parsedFromAnalytics);
    const filteredAnalyticsProps = pick(analytics, keysToReplace);
    Object.assign(appState.parsedFromAnalytics, filteredAnalyticsProps);
  }

  return appState;
};
